module.exports = __webpack_public_path__ + "static/media/lightAddPost.d21e3b15.svg";